// import React from "react";
// import { Label } from "../../../../Components/ui/label";
// import { Switch } from "../../../../Components/ui/switch";
// import {
//   Select,
//   SelectTrigger,
//   SelectValue,
//   SelectContent,
//   SelectItem,
// } from "../../../../Components/ui/select";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionTrigger,
//   AccordionContent,
// } from "../../../../Components/ui/accordion";
// import RoamingDaysSection from "./RoamingDaysSection";

// interface AdvancedSettingsCardProps {
//   allocationType: string;
//   setAllocationType: React.Dispatch<React.SetStateAction<string>>;
//   roamingAge: string;
//   setRoamingAge: React.Dispatch<React.SetStateAction<string>>;
//   isDuplicatePrevented: boolean;
//   setIsDuplicatePrevented: React.Dispatch<React.SetStateAction<boolean>>;
//   isPremiumOnly?: boolean;
//   setIsPremiumOnly?: React.Dispatch<React.SetStateAction<boolean>>;
//   locked?: boolean;

//   // NEW: Values passed instead of context
//   roamingDaysByCountry: any;
//   setRoamingDaysByCountry: React.Dispatch<any>;
//   fromCountryISOs: Record<string, string>;
//   fromCountries: string[];
// }

// const AdvancedSettingsCard: React.FC<AdvancedSettingsCardProps> = ({
//   allocationType,
//   setAllocationType,
//   roamingAge,
//   setRoamingAge,
//   isDuplicatePrevented,
//   setIsDuplicatePrevented,
//   isPremiumOnly,
//   setIsPremiumOnly,
//   locked = true,

//   // new props
//   roamingDaysByCountry,
//   setRoamingDaysByCountry,
//   fromCountryISOs,
//   fromCountries,
// }) => {
//   const isLocked = locked;

//   return (
//     <Accordion type="single" collapsible className="w-full">
//       <AccordionItem value="advanced-settings" className="border-b-0">
//         <AccordionTrigger className="text-base font-bold text-[#020617]">
//           Advanced Settings
//         </AccordionTrigger>

//         <AccordionContent>
//           <div className="space-y-4 mt-2">

//             {/* Premium Contacts Only */}
//             <div className="flex items-center gap-20">
//               <Label className="font-medium text-[#020617] text-sm w-48">
//                 Premium Contacts Only
//               </Label>
//               <Switch
//                 checked={!!isPremiumOnly}
//                 onCheckedChange={isLocked ? undefined : setIsPremiumOnly}
//                 disabled={isLocked}
//                 className="h-6 w-10"
//               />
//             </div>

//             {/* Prevent Duplicate Messages */}
//             <div className="flex items-center gap-20">
//               <Label className="font-medium text-[#020617] text-sm w-48">
//                 Prevent Duplicate Messages
//               </Label>
//               <Switch
//                 checked={isDuplicatePrevented}
//                 onCheckedChange={isLocked ? undefined : setIsDuplicatePrevented}
//                 disabled={isLocked}
//                 className="h-6 w-10"
//               />
//             </div>

//             {/* Allocation Type */}
//             <div className="flex items-center gap-20">
//               <Label className="font-medium text-[#020617] text-sm w-48">
//                 Allocation Type
//               </Label>

//               <Select
//                 value={allocationType}
//                 onValueChange={isLocked ? () => {} : setAllocationType}
//               >
//                 <SelectTrigger
//                   disabled={isLocked}
//                   className="h-8 w-44 bg-white"
//                 >
//                   <SelectValue />
//                 </SelectTrigger>

//                 <SelectContent>
//                   <SelectItem value="Daily Allocation">Daily Allocation</SelectItem>
//                   <SelectItem value="Lifetime Allocation">Lifetime Allocation</SelectItem>
//                 </SelectContent>
//               </Select>
//             </div>

//             {/* Roaming Days */}
//             <RoamingDaysSection
//               isViewMode={isLocked}
//               roamingDaysByCountry={roamingDaysByCountry}
//               setRoamingDaysByCountry={setRoamingDaysByCountry}
//               fromCountryISOs={fromCountryISOs}
//               fromCountries={fromCountries}
//             />
//           </div>
//         </AccordionContent>
//       </AccordionItem>
//     </Accordion>
//   );
// };

// export default AdvancedSettingsCard;

import React from "react";
import { Label } from "../../../../Components/ui/label";
import { Switch } from "../../../../Components/ui/switch";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../../../Components/ui/select";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../../../Components/ui/accordion";
import RoamingDaysSection from "./RoamingDaysSection";

interface AdvancedSettingsCardProps {
  allocationType: string;
  setAllocationType: React.Dispatch<React.SetStateAction<string>>;
  roamingAge: string;
  setRoamingAge: React.Dispatch<React.SetStateAction<string>>;
  isDuplicatePrevented: boolean;
  setIsDuplicatePrevented: React.Dispatch<React.SetStateAction<boolean>>;
  isPremiumOnly?: boolean;
  setIsPremiumOnly?: React.Dispatch<React.SetStateAction<boolean>>;
  locked?: boolean;

  // NEW: Audience Type props
  audienceType?: string;
  selectedCampaignName?: string;

  // Roaming Days props
  roamingDaysByCountry: any;
  setRoamingDaysByCountry: React.Dispatch<any>;
  fromCountryISOs: Record<string, string>;
  fromCountries: string[];
}

const AdvancedSettingsCard: React.FC<AdvancedSettingsCardProps> = ({
  allocationType,
  setAllocationType,
  roamingAge,
  setRoamingAge,
  isDuplicatePrevented,
  setIsDuplicatePrevented,
  isPremiumOnly,
  setIsPremiumOnly,
  locked = true,

  // NEW props
  audienceType,
  selectedCampaignName,

  // roaming days props
  roamingDaysByCountry,
  setRoamingDaysByCountry,
  fromCountryISOs,
  fromCountries,
}) => {
  const isLocked = locked;

  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="advanced-settings" className="border-b-0">
        <AccordionTrigger className="text-base font-bold text-[#020617]">
          Advanced Settings
        </AccordionTrigger>

        <AccordionContent>
          <div className="space-y-4 mt-2">

            {/* Premium Contacts Only */}
            <div className="flex items-center gap-20">
              <Label className="font-medium text-[#020617] text-sm w-48">
                Premium Contacts Only
              </Label>
              <Switch
                checked={!!isPremiumOnly}
                onCheckedChange={isLocked ? undefined : setIsPremiumOnly}
                disabled={isLocked}
                className="h-6 w-10"
              />
            </div>

            {/* Prevent Duplicate Messages */}
            <div className="flex items-center gap-20">
              <Label className="font-medium text-[#020617] text-sm w-48">
                Prevent Duplicate Messages
              </Label>
              <Switch
                checked={isDuplicatePrevented}
                onCheckedChange={isLocked ? undefined : setIsDuplicatePrevented}
                disabled={isLocked}
                className="h-6 w-10"
              />
            </div>

            {/* Allocation Type */}
            <div className="flex items-center gap-20">
              <Label className="font-medium text-[#020617] text-sm w-48">
                Allocation Type
              </Label>

              <Select
                value={allocationType}
                onValueChange={isLocked ? () => { } : setAllocationType}
              >
                <SelectTrigger
                  disabled={isLocked}
                  className="h-8 w-44 bg-white"
                >
                  <SelectValue />
                </SelectTrigger>

                <SelectContent>
                  <SelectItem value="Daily Allocation">Daily Allocation</SelectItem>
                  <SelectItem value="Lifetime Allocation">Lifetime Allocation</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Audience Type */}
            {audienceType && (
              <div className="flex items-center gap-20">
                <Label className="font-medium text-[#020617] text-sm w-48">
                  Audience Type
                </Label>
                <Select value={audienceType} disabled>
                  <SelectTrigger disabled className="h-8 w-44 bg-white">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="None">None</SelectItem>
                    <SelectItem value="Reuse Audience">Reuse Audience</SelectItem>
                    <SelectItem value="New Audience">New Audience</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            )}

            {/* Selected Campaign (only show if Reuse Audience) */}
            {audienceType === "Reuse Audience" && selectedCampaignName && (
              <div className="flex items-center gap-20">
                <Label className="font-medium text-[#020617] text-sm w-48">
                  Selected Campaign
                </Label>
                <Select value={selectedCampaignName} disabled>
                  <SelectTrigger disabled className="h-8 w-44 bg-white">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value={selectedCampaignName}>
                      {selectedCampaignName}
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>
            )}

            {/* Roaming Days */}
            <RoamingDaysSection
              isViewMode={isLocked}
              roamingDaysByCountry={roamingDaysByCountry}
              setRoamingDaysByCountry={setRoamingDaysByCountry}
              fromCountryISOs={fromCountryISOs}
              fromCountries={fromCountries}
            />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default AdvancedSettingsCard;